import { actions } from '@grandvisionhq/state';

const startPrescriptionGlassesConfiguration = actions.action('products/prescription-glasses/start', actions.payload());
actions.action('products/prescription-glasses/next-step');
actions.action('products/prescription-glasses/next-step-success', actions.payload());
actions.action('products/prescription-glasses/next-step-failed', actions.payload());
actions.action('products/prescription-glasses/previous-step');
actions.action('products/prescription-glasses/previous-step-failed', actions.payload());
actions.action('products/prescription-glasses/previous-step-success', actions.payload());

export { startPrescriptionGlassesConfiguration };
//# sourceMappingURL=actions.js.map
